<template>
  <div>
    <v-divider v-if="divider"></v-divider>

    <v-list-item @click="onSelect(false)">
      <v-list-item-avatar>
        <v-icon v-if="!icon">business</v-icon>
        <v-img v-if="icon" :lazy-src="icon" :src="icon"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="resource.resource.title"></v-list-item-title>
        <v-list-item-subtitle v-if="resource.roles && resource.roles.length">
          <v-chip v-for="(role, r) in resource.roles" :key="r" x-small class="my-1">{{ role }}</v-chip>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{ resource.resource.sub_title }}
          <span v-if="user.admin"> | {{ resource.login.email }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-tooltip left v-if="showFavourite">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click.stop="onFavourite()">
              {{ favourite ? 'star' : 'star_outline' }}
            </v-icon>
          </template>
          <span>{{ favourite ? 'Remove from' : 'Add to' }} favourites</span>
        </v-tooltip>
        <v-tooltip left v-if="user.admin && showAdmin">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click.stop="onSelect(true)">
              lock_open
            </v-icon>
          </template>
          <span>Login as administrator</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "ResourcesListItem",

  props: [
    'applicationID',
    'user',
    'resource',
    'divider',
    'favourite',
    'showFavourite'
  ],

  emits: [
    'select',
    'favourite',
  ],

  computed: {
    showAdmin() {
      return [
        'dc4299f7-db63-400a-3866-6465-3635-3164-6333-6632-e58a-2d60e7f4ee7b',
      ]
          .indexOf(this.applicationID) !== -1;
    },
    icon() {
      switch (this.resource.resource.type) {
        case 'core':
          return this.$api.url('/icons/' + this.resource.resource.id);
        default:
          return this.resource.resource.icon;
      }
    }
  },
  methods: {
    onSelect(adminMode) {
      adminMode = !!adminMode;
      this.$emit('select', this.resource, adminMode);
    },
    onFavourite() {
      this.$emit('favourite', this.resource, !this.favourite);
    }
  },
}
</script>

<style scoped>
.v-avatar {
  background-color: #e0e0e0;
}
</style>
